import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { updateHomeworkStatus } from "../../../api/endpoints/HomeworkEndpoints";
import { Homework } from "../../../models/Homework";

export default function useUpdateHomeworkStatus(homeworkId: string) {
  return useMutation<
    void,
    AxiosError,
    { status: { status: Homework["status"]; message?: string } }
  >({
    mutationKey: ["update-homework", homeworkId],
    mutationFn: ({ status }) => updateHomeworkStatus(homeworkId, status),
  });
}
